import { FC, memo } from 'react'
import { Flex, Text, Badge } from '@chakra-ui/react'

import { Citizen } from 'CitizenProfile/types'
import { CATEGORIES_OBJECT } from 'constants/variables'

type CitizenPlaceFields = {
  healthPlace: boolean
  schoolPlace: boolean
  socialPlace: boolean
  govPlace: boolean
}

type Props = {
  citizen: Citizen
  citizenPlaceFields: CitizenPlaceFields
}

const CitizenCardPlaces: FC<Props> = ({ citizen, citizenPlaceFields }) => {
  return (
    <Flex width="100%" direction="column" gap={1}>
      <Text variant="secondary" mb={2}>
        Locais
      </Text>

      {citizenPlaceFields.healthPlace && (
        <Flex alignItems="center" gap={1}>
          <Badge variant="subtle" colorScheme={CATEGORIES_OBJECT.HEALTH.color}>
            Saúde:
          </Badge>
          <Text>{citizen.health_place_name || ' '}</Text>
        </Flex>
      )}
      {citizenPlaceFields.schoolPlace && (
        <Flex alignItems="center" gap={1}>
          <Badge variant="subtle" colorScheme={CATEGORIES_OBJECT.EDUCATION.color}>
            Educação:
          </Badge>
          <Text>{citizen.school_place_name || ' '}</Text>
        </Flex>
      )}
      {citizenPlaceFields.socialPlace && (
        <Flex alignItems="center" gap={1}>
          <Badge variant="subtle" colorScheme={CATEGORIES_OBJECT.SOCIAL.color}>
            Social:
          </Badge>
          <Text>{citizen.social_place_name || ' '}</Text>
        </Flex>
      )}
      {citizenPlaceFields.govPlace && (
        <Flex alignItems="center" gap={1}>
          <Badge variant="subtle" colorScheme={CATEGORIES_OBJECT.GOV.color}>
            Gov:
          </Badge>
          <Text>{citizen.gov_place_name || ' '}</Text>
        </Flex>
      )}
    </Flex>
  )
}

export default memo(CitizenCardPlaces)
